module.exports = __webpack_public_path__ + "static/img/introduction-environmental-strategy-sustainability.0b3ebac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-environmental-strategy-sustainability.jpg
// module id = XNu0
// module chunks = 0